import { useEffect, useState } from "react";
import { Constant } from "../../../../../config";
import { Notify, Utils } from "../../../../../utils";
import { useAppSelector } from "../../../../../_app";
import { LeaveService } from "../../../../../_service";
import { LoaderContainer } from "../../../../../CommonStyles";
import {
  CustomButton,
  CustomSelectField,
  CustomeCkeckboxField,
  Loader,
} from "../../../../../components";
import {
  AllNoneButton,
  AllNoneContainer,
  ButtonContainer,
  GeneralSettingsContainer,
  LeaveSettingsHeading,
  LeaveSettingsSubHeading,
} from "../../SelfServiceStyles";
import { useNavigate } from "react-router-dom";
import { SelfService } from "../../../../../_service/SelfService";
import cloneDeep from "lodash.clonedeep";

const LeaveSettings = () => {
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [leaveList, setLeaveList] = useState<any>([]);
  const [selectedLeave, setSelectedLeave] = useState<any>([]);
  const [approverCanSee, setApproverCanSee] = useState("No Employees");
  const [employeeCanSee, setEmployeeCanSee] = useState("No Employees");

  const canSeeOptions = [
    "No Employees",
    "All Employees",
    "Employees they can approve",
  ];

  const user = useAppSelector((state) => state.user);
  const navigate = useNavigate();

  // const toggleLeaveSelect = (leaveId: any) => {
  //   const leaveData = [...selectedLeave];
  //   const index = leaveData.indexOf(leaveId);

  //   if (index !== -1) {
  //     leaveData.splice(index, 1);
  //   } else {
  //     leaveData.push(leaveId);
  //   }
  //   console.log(leaveData);

  //   setSelectedLeave(() => leaveData);
  // };

  const getLeaveTypes = async () => {
    try {
      if (user?.defaultCompnayId) {
        const { data, status } = await LeaveService._getLeaveTypes(
          parseInt(user.defaultCompnayId)
        );

        if (status === 200) {
          setLeaveList(() => data.data);
        }
      }
    } catch (error) {
      Notify(Constant.common.something_went_wrong, 0);
    }
  };

  // const getSelfServiceSettings = async () => {
  //   setIsLoading(() => true);
  //   try {
  //     const { data, status } = await SelfService._getSelfServiceSettings(
  //       user.defaultCompnayId
  //     );
  //     if (status === 200) {
  //       const { approver_can_see, employee_can_see, leaves } = data.data;

  //       setApproverCanSee(() => approver_can_see);
  //       setEmployeeCanSee(() => employee_can_see);
  //       if (leaves) {
  //         setSelectedLeave(() => [...leaves]);
  //       }
  //     }
  //   } catch (err) {
  //     Notify(Constant.common.something_went_wrong, 0);
  //   }
  //   setIsLoading(() => false);
  // };

  // const postSelfServiceSettings = async () => {
  //   setIsLoading(() => true);
  //   try {
  //     const dataToSend = {
  //       company: user.defaultCompnayId,
  //       approver_can_see: approverCanSee,
  //       employee_can_see: employeeCanSee,
  //       leaves: [...selectedLeave],
  //     };
  //     const { status } = await SelfService._postSelfServiceSettings(dataToSend);
  //     if (status === 201) {
  //       Notify("Settings updated Successfully", 1);
  //       getSelfServiceSettings();
  //     }
  //   } catch (err) {
  //     Notify(Constant.common.something_went_wrong, 0);
  //   }
  //   setIsLoading(() => false);
  // };

  const handleSave = async () => {
    setIsLoading(() => true);
    try {
      const { status } = await SelfService._saveSelfServiceLeaveSettings(leaveList);
      if (status >= 200 && status < 300) {
        Notify("Settings updated Successfully", 1);
        getLeaveTypes();
      }
    } catch (error : any) {
      Utils.showErrorMessage(error);
    }
    setIsLoading(() => false);
  };

  useEffect(() => {
    getLeaveTypes();
    // getSelfServiceSettings();
  }, []);

  const handleToggle = (leaveId: any) => {
    const leaveData = cloneDeep(leaveList);
    const index = leaveData.findIndex((leave: any) => leave.id === leaveId);
    if (index !== -1) {
      leaveData[index].is_hide_bal_in_self_service =
        !leaveData[index].is_hide_bal_in_self_service;
      setLeaveList(() => leaveData);

      if (!leaveData[index].is_hide_bal_in_self_service) {
        // Add to selectedLeave
        setSelectedLeave((prevSelected: any) => [
          ...prevSelected,
          leaveId,
        ]);
      } else {
        // Remove from selectedLeave
        setSelectedLeave((prevSelected: any) =>
          prevSelected.filter((id: any) => id !== leaveId)
        );
      }
    }
  };

  const handleAllNone = (selectAll: boolean) => {
    if (selectAll) {
      const allLeaveIds = leaveList.map((leave: any) => leave.id);
      setSelectedLeave(() => allLeaveIds);
      const updatedLeaveList = leaveList.map((leave: any) => ({
        ...leave,
        is_hide_bal_in_self_service: false,
      }));
      setLeaveList(() => updatedLeaveList);
    } else {
      setSelectedLeave(() => []);
      const updatedLeaveList = leaveList.map((leave: any) => ({
        ...leave,
        is_hide_bal_in_self_service: true,
      }));
      setLeaveList(() => updatedLeaveList);
    }
  };

  console.log('selectedLeave', selectedLeave);

  return (
    <div>
      {isLoading ? (
        <LoaderContainer>
          <Loader />
        </LoaderContainer>
      ) : (
        <>
          {/* <CustomSelectField
            title="Approvers can see overview for"
            value={approverCanSee}
            onChangeOption={(value) => setApproverCanSee(value)}
            option={canSeeOptions.map((optionData) => ({
              key: optionData,
              value: optionData,
            }))}
          />
          <CustomSelectField
            title="Employees can see overview for"
            value={employeeCanSee}
            onChangeOption={(value) => setEmployeeCanSee(value)}
            option={canSeeOptions.map((optionData) => ({
              key: optionData,
              value: optionData,
            }))}
          /> */}
          <LeaveSettingsHeading>Display Leave Balances</LeaveSettingsHeading>
          <LeaveSettingsSubHeading>
            Minimum balance warnings will still be visible for all types, if
            enabled.
          </LeaveSettingsSubHeading>
          <AllNoneContainer>
            <AllNoneButton
              onClick={() =>
                handleAllNone(true)
              }
            >
              All
            </AllNoneButton>
            <AllNoneButton onClick={() => handleAllNone(false)}>
              None
            </AllNoneButton>
          </AllNoneContainer>
          <GeneralSettingsContainer>
            {leaveList.map((leave: any) => (
              <CustomeCkeckboxField
                title={leave.name}
                value={leave?.is_hide_bal_in_self_service ? false : true}
                onChange={() => handleToggle(leave.id)}
              />
            ))}
          </GeneralSettingsContainer>
          <ButtonContainer>
            <CustomButton
              type="secondary"
              title="Cancel"
              onClick={() => navigate("/dashboard/self-service/employee-users")}
            />
            <CustomButton
              title="Save"
              onClick={() => handleSave()}
            />
          </ButtonContainer>
        </>
      )}
    </div>
  );
};

export default LeaveSettings;
